'use client';

import React, { Component } from 'react';
import Link from 'next/link';
import MobileHeaderActions from './modules/MobileHeaderActions';

class HeaderMobile extends Component {
    render() {
        return (
            <header className="header header--mobile">
                <div className="navigation--mobile">
                    <div className="navigation__left">
                        <Link href="/" className="ps-logo">
                            <img
                                src="/static/img/logo_light.png"
                                alt="rawento"
                                suppressHydrationWarning
                            />
                        </Link>
                    </div>
                    <MobileHeaderActions />
                </div>
            </header>
        );
    }
}

export default HeaderMobile;